import React from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import moment from 'moment';

import AddSubseasonModal from './AddSubseasonModal';
import SubseasonAdmin from './SubseasonAdmin';

class SeasonAdmin_subs extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			season: this.props.season,
			showAddSubseasonModal: false,
			showEditSubseason: false,
			subseasonEditId: '0'
		};
	
		this.createSubseasonRow = this.createSubseasonRow.bind(this);
		this.handleEditSubseason = this.handleEditSubseason.bind(this);
		this.handleDeleteSubSeason = this.handleDeleteSubSeason.bind(this);
	}

 	componentDidMount() {
		// console.log('SeasonAdmin_subs: componentDidMount');
		this.setState({
			season: this.props.season,
		});
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		// console.log('SeasonAdmin_subs: UNSAFE_componentWillReceiveProps: ');
		this.setState({
			season: nextProps.season,
		});
	}

	render() {
		console.log('SeasonAdmin_subs: RENDER');
		const { season, showAddSubseasonModal, showEditSubseason } = this.state;

		// Prevent undefined causing errors when reloading page (props not being set early)
		var subSeasons = [];
  	var subSeasonsLength = 0;
  	if (season.subSeasons) {
  		subSeasons = season.subSeasons
  		subSeasonsLength = season.subSeasons.length;	
  	}

    // ADMIN LEVEL REQUESTED:  03-SEASON
/*
		if (!connectedUser.isSeasonAdmin) {
      return (
        <div className="col-md-9">
          <p>Vous n'avez pas accès à cette section pour la saison sélectionnée</p>
        </div>
      );
        
    } else {
*/    	
			if (season._id === "0") {
	      return (
          <div className="col-md-9">
            <p>Vous devez d'abord créer une saison pour cette ligue dans l'onglet Ligue</p>
          </div>
        );

			} else {
				return (
          <div>
		        <div className="row">
		        <div className="col-12">

						<div className="card">
							<div className="card-header">
							<i className="fa fa-th-large"></i>
								<span className="card-header-text">Sous-saisons</span>
							</div>

							<div className="card-block table-responsive">
							<table className="table table-striped table-hover table-sm">
							<tbody>
								<tr>
									<th></th>
	                <th>Id</th>
									<th>Sous-saisons</th>
	                <th>Début</th>
	                <th>Divisions</th>
	                <th>Finale</th>
	                <th></th>
								</tr>
								{subSeasons.map(this.createSubseasonRow)}
							</tbody>
							</table>

				      <button className="btn btn-primary" onClick={() => this.setState({ showAddSubseasonModal: true })}>
				        Ajouter une Sous-saison
				      </button>
							</div>
						</div>
          </div>

	        <div className="col-10">
						{showEditSubseason ? 
							<SubseasonAdmin season={season} ssid={this.state.subseasonEditId} 
								reloadSeason={this.props.reloadSeason} />
						: null}
          </div>
          </div>

          <AddSubseasonModal
					  showModal={showAddSubseasonModal}
					  handleModalCancel={() => this.setState({ showAddSubseasonModal: false })}
					  seasonId={season._id}
					  ssid={subSeasonsLength}
					  reloadSeason={this.props.reloadSeason}
					/>
          </div>
        );
			}
		//}
  }

  createSubseasonRow(subseason, subSeasonIdx) {
  	var typeFinals = "";
  	if (subseason.typeFinals) {
  		typeFinals = "FINALE";
  	}

		var startDate = moment(subseason.startDate).utc().format("YYYY-MM-DD");
		return (
			<tr key={subseason.id}>
        <td><input name={'edit.' + subseason.id} type="button" onClick={this.handleEditSubseason} value="Éditer"/></td>
				<td>{subseason.id}</td>
				<td>{subseason.name}</td>
				<td>{startDate}</td>
				<td>{subseason.divisions.length}</td>
				<td>{typeFinals}</td>
        <td><input id={"remSubSeason." + subSeasonIdx} type="button" onClick={this.handleDeleteSubSeason} value="Supprimer"/></td>
      </tr>
    );
  }

  handleEditSubseason(e) {
    var elemInfo = e.target.name.split(".");
    var subseasonEditId = elemInfo[1];
    this.setState({showEditSubseason: true, subseasonEditId: subseasonEditId});
  }

	handleDeleteSubSeason(e) {
		// Autosave post to database
		var ssIdx = parseInt(e.target.id.split(".")[1]);

		var season = this.state.season;
		season.subSeasons.splice(ssIdx, 1);

		// reIndex data
		season.subSeasons.forEach((ssItem, ssIdx) => {
			ssItem.id = String(ssIdx);
		});

		this.setState({
			season: season
		});

		Axios.post('/api/seasons/' + this.state.season._id, {
			season: this.state.season,
		})
		.then(response => {
			// console.log(response);
		})
		.catch(function(error) {
			console.log(error);
		});
	}

}

export default SeasonAdmin_subs;
